export default "__VITE_PUBLIC_ASSET__e7dfb39b__"